<template>
    <div v-if="isVideo">
        <div class="h3" style="margin-top: 5px">
            {{ t.content.learning_progress }}
        </div>
        <div class="package-learning-progress-icons" :title="certificateTitle">
            <div class="progress-circle">
                <svg
                    class="svg"
                    width="200"
                    height="200"
                    viewBox="0 0 200 200"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        r="90"
                        cx="100"
                        cy="100"
                        fill="transparent"
                        stroke-dasharray="565.48"
                        stroke-dashoffset="0"
                    ></circle>
                    <circle
                        v-if="progress !== 100"
                        class="bar"
                        r="90"
                        cx="100"
                        cy="100"
                        fill="transparent"
                        stroke-dasharray="565.48"
                        stroke-dashoffset="0"
                        :style="'stroke-dashoffset: ' + 565.48 * ((100 - progress) / 100) + 'px'"
                    ></circle>
                </svg>
                <div class="percentage" :class="'p' + progress">{{ progress }}<span>%</span></div>
            </div>
            <a :href="url + '/quiz'" v-if="hasQuiz && !hasCertificate && progress >= acceptToProgress">
                <i class="icon certificate-icon waiting-certificated"></i>
            </a>
            <a :href="url + '/certificate/download'" class="certificateDownload" v-else-if="hasCertificate">
                <i
                    id="icon-certificate"
                    class="icon certificate-icon certificated"
                    :class="hasCertificateDownloaded ? ' downloaded' : ''"
                ></i>
            </a>
            <i v-else class="icon certificate-icon not-certificated"></i>
        </div>
    </div>
</template>

<script>
import axios from "@/app/axios.ts"
const translationsData = window.translationsData

export default {
    name: "ProgressCircle",
    components: {},
    props: ["packageId"],
    data() {
        return {
            t: translationsData.translations,
            globalRoute: translationsData.global_route,
            isVideo: false,
            progress: 0,
            hasCertificate: false,
            hasCertificateDownloaded: false,
            hasQuiz: false,
            url: "",
            certificateTitle: "",
            acceptToProgress: false,
        }
    },
    mounted() {},
    methods: {
        async getProgress() {
            const headers = {
                "Content-Type": "application/json; charset=UTF-8",
                "X-CSRF-TOKEN": document.querySelector("meta[name=csrf-token]").content,
                "X-Robots-Tag": "noindex, nofollow",
            }
            const response = await axios.post(
                `/${this.globalRoute.locale}/package/get-progress`,
                { package_id: this.packageId },
                {
                    headers: headers,
                },
            )
            if (response) {
                this.isVideo = response.data.isVideo
                this.progress = response.data.progress
                this.hasCertificate = response.data.hasCertificate
                this.hasCertificateDownloaded = response.data.hasCertificateDownloaded
                this.hasQuiz = response.data.has_quiz
                this.url = response.data.url
                this.certificateTitle = response.data.certificateTitle
                this.acceptToProgress = response.data.acceptToProgress
            }
        },
    },
    created() {
        this.getProgress()
    },
}
</script>

<style lang="scss" scoped>
.content-buttons-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
}
</style>
